export const calcCharWidth = (value: string) => {
  return value.split('').map(c => c.charCodeAt(0) <= 0xFF ? 1 : 2).reduce((a, b) => a + b, 0);
}
